import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const StoreLoginLayout = loadable(() => import('./storeLogin'), {
  fallback: <FullPageLoader />,
});
